type CustomerNameInput = {
  first_name?: string | null
  last_name?: string | null
}

export const formatCustomerName = ({ first_name, last_name }: CustomerNameInput): string => {
  return [first_name, last_name].filter(Boolean).join(' ')
}
